import { Icon16ErrorCircleOutline } from '@vkontakte/icons';
import React from 'react';

export const enum TitleVariants {
    ERROR = 'error',
}

const titleIcons = {
    [TitleVariants.ERROR]: <Icon16ErrorCircleOutline color="var(--vkui--color_text_negative)" />,
} as const;

export const getTitleIcon = (variant?: TitleVariants) => variant && titleIcons[variant];
